var _path, _path2, _rect, _rect2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendarBlue2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.5703C5 11.2566 7.68629 8.57031 11 8.57031H29C32.3137 8.57031 35 11.2566 35 14.5703V28.9989C35 32.3126 32.3137 34.9989 29 34.9989H11C7.68629 34.9989 5 32.3126 5 28.9989V14.5703Z",
    fill: "#A9D1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.5703C5 11.2566 7.68629 8.57031 11 8.57031H29C32.3137 8.57031 35 11.2566 35 14.5703V17.1417H5V14.5703Z",
    fill: "#166DD7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.4287,
    y: 4.28906,
    width: 2.85714,
    height: 8.57143,
    rx: 1.42857,
    fill: "#A9D1FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7144,
    y: 4.28906,
    width: 2.85714,
    height: 8.57143,
    rx: 1.42857,
    fill: "#A9D1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0896 18.9289C28.6806 19.4517 28.7358 20.3545 28.2131 20.9454L20.0925 30.1252C19.5216 30.7706 18.5375 30.8359 17.8863 30.2716L12.636 25.7213C12.0398 25.2046 11.9754 24.3024 12.4921 23.7061C13.0088 23.1099 13.9111 23.0455 14.5073 23.5622L18.7958 27.2789L26.0731 19.0524C26.5958 18.4614 27.4987 18.4061 28.0896 18.9289Z",
    fill: "#166DD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarBlue2);
export default __webpack_public_path__ + "static/media/icon-calendar-blue2.4e3a14139f0f82346ad28b4dca605934.svg";
export { ForwardRef as ReactComponent };